module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-fill"
  }, [_c('div', {
    staticClass: "container py-3"
  }, [_c('div', {
    staticClass: "row justify-content-center h-100"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-6"
  }, [_c('div', {
    staticClass: "d-flex flex-column w-100 h-100"
  }, [_c('div', {
    staticClass: "radius-normal py-2 px-3 mb-2 w-100",
    style: (_vm.productColor)
  }, [_c('event-details', {
    attrs: {
      "reservation": _vm.reservation,
      "disabled": _vm.isReservationReadOnly && _vm.reservation.status != -5
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "border-light radius-normal py-2 px-3 mb-2 w-100 flex-grow-1"
  }, [_c('reservation-ticket-prices', {
    attrs: {
      "reservation": _vm.reservation
    },
    on: {
      "toggleEditPax": _vm.toggleEditPax
    }
  })], 1), _vm._v(" "), _c('div', {}, [_c('reservation-other-extras', {
    attrs: {
      "reservation": _vm.reservation
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-6 mt-sm-2 mt-sm-2 mt-lg-0"
  }, [_c('div', {
    staticClass: "d-flex flex-column w-100 h-100"
  }, [_c('div', {
    staticClass: "border-light radius-normal py-2 flex-grow-1 mb-2"
  }, [_c('checkins', {
    attrs: {
      "disabled": _vm.disabled || _vm.isEditingPax,
      "reservation": _vm.reservation
    }
  })], 1), _vm._v(" "), _c('price-total', {
    staticClass: "border-light radius-normal",
    attrs: {
      "disabled": _vm.disabled,
      "reservation": _vm.reservation
    }
  })], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-67ce784e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67ce784e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TabReservation/TabReservation.vue
// module id = 1924
// module chunks = 0